import Vue from "vue";
const vm = new Vue()

export const getListUser = async () => {
    return new Promise((resolve, reject) => {
        vm.$http.get( vm.$API_URL + "/users" , {
            headers: {
                Token: localStorage.getItem("access_token")
            }
            }).then( res => {
                if (!res.data.status) {   
                    reject(res.data.error.msg);
                }
                resolve(res.data.data)
            })
    })
}